module.exports = __webpack_public_path__ + "img/return.d62f35c7.svg";